import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { bootstrapI18n } from '@vendasta/galaxy/i18n';
import { LEXICON_FILE_FORMAT_OPTION } from '@galaxy/lexicon';
import { AppModule } from './app/app.module';
import { devServer, environment } from './globals';
import En from './assets/i18n/en_devel.json';
import { Network } from '@capacitor/network';
import { Capacitor } from '@capacitor/core';

if (!devServer) {
  enableProdMode();
}

function isMockSession(session: string | null): boolean {
  return session !== null && session.endsWith('.nexus-mock-signature');
}

function clearMockSession(): void {
  const session = localStorage.getItem('local_session');
  if (isMockSession(session)) {
    localStorage.removeItem('local_session');
    delete (globalThis as any).iamSession;
  }
}

const getNetworkStatus = async () => {
  const status = await Network.getStatus();
  if (!status.connected) {
    alert('You are not connected to the internet. Please check your network settings and open the app again.');
    navigator['app'].exitApp();
  }
};

if (Capacitor.isNativePlatform()) {
  getNetworkStatus();
}

const WEBLATE_COMPONENT_NAME = 'business-center/business-center-client';
const BASE_TRANSLATIONS = En;
bootstrapI18n(
  WEBLATE_COMPONENT_NAME,
  BASE_TRANSLATIONS,
  null,
  LEXICON_FILE_FORMAT_OPTION.NESTED_JSON,
  false,
  environment,
);

function checkMocksEnabled(): boolean {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('mocks')) {
    const enabled = urlParams.get('mocks') === 'true';
    if (enabled) {
      sessionStorage.setItem('mocks', 'true');
    } else {
      sessionStorage.removeItem('mocks');
      clearMockSession();
    }
    return enabled;
  }
  if (sessionStorage.getItem('mocks') === 'true') return true;
  return (globalThis as any).enableMocks === true;
}

async function bootstrap() {
  const mocksEnabled = checkMocksEnabled();

  if (!mocksEnabled) {
    clearMockSession();
  }

  if (mocksEnabled) {
    try {
      const { startMSW } = await import('./mocks/browser');
      const started = await startMSW();
      if (!started) {
        sessionStorage.removeItem('mocks');
      }
    } catch (err) {
      console.error('[MSW] Failed to start, continuing without mocks:', err);
      sessionStorage.removeItem('mocks');
    }
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
}

bootstrap();
